var _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg1",
    width: 1270.6667,
    height: 238.66667,
    viewBox: "0 0 1270.6667 238.66667",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,179 H 953 V 0 H 0 Z",
    transform: "translate(-108.2656,-94.0467)",
    id: "path2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,179 H 953 V 0 H 0 Z",
    transform: "translate(-225.51781,-49.376901)",
    id: "path4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,179 H 953 V 0 H 0 Z",
    transform: "translate(-333.00001,-142.2708)",
    id: "path6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,179 H 953 V 0 H 0 Z",
    transform: "translate(-299.00001,-142.5)",
    id: "path8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,179 H 953 V 0 H 0 Z",
    id: "path10"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,179 H 953 V 0 H 0 Z",
    transform: "translate(-617.33732,-164.3661)",
    id: "path12"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,179 H 953 V 0 H 0 Z",
    transform: "translate(-717.74792,-49.413201)",
    id: "path14"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,179 H 953 V 0 H 0 Z",
    transform: "translate(-837.10112,-48.643004)",
    id: "path16"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,179 H 953 V 0 H 0 Z",
    transform: "translate(-952.99982,-43.733001)",
    id: "path18"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,179 H 953 V 0 H 0 Z",
    transform: "translate(-410.34241,-68.742802)",
    id: "path20"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,179 H 953 V 0 H 0 Z",
    transform: "translate(-394.00001,-95.000002)",
    id: "path22"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,179 H 953 V 0 H 0 Z",
    transform: "translate(-328.50001,-59.500004)",
    id: "path24"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,179 H 953 V 0 H 0 Z",
    transform: "translate(-377.00001,-145)",
    id: "path26"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "layer-MC0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1",
    d: "m 0,0 c 0,-6.532 -0.934,-12.841 -2.803,-18.925 -1.869,-6.084 -4.737,-11.591 -8.604,-16.523 -3.802,-4.867 -8.732,-8.741 -14.789,-11.623 -5.994,-2.818 -12.986,-4.227 -20.977,-4.227 -6.444,0 -11.535,0.672 -15.273,2.017 -3.673,1.345 -7.347,3.138 -11.02,5.38 v -50.146 h -34.8 V 48.224 h 34.8 v -8.838 c 3.48,3.01 7.314,5.508 11.503,7.493 4.254,2.05 9.989,3.074 17.207,3.074 7.153,0 14.177,-1.761 21.073,-5.283 6.895,-3.523 12.566,-9.03 17.013,-16.523 C -2.223,20.718 0,11.336 0,0 m -36.636,-0.769 c 0,5.892 -0.935,10.664 -2.804,14.314 -1.868,3.715 -4.285,6.372 -7.25,7.973 -2.964,1.665 -6.025,2.498 -9.183,2.498 -4.124,0 -7.508,-0.672 -10.15,-2.017 -2.642,-1.281 -5.123,-2.914 -7.443,-4.9 V -20.27 c 1.224,-0.64 2.513,-1.376 3.867,-2.209 1.417,-0.768 2.803,-1.441 4.156,-2.017 1.418,-0.577 2.9,-1.057 4.447,-1.441 1.611,-0.385 3.319,-0.577 5.123,-0.577 5.478,0 10.053,2.306 13.727,6.917 3.673,4.611 5.51,10.887 5.51,18.828",
    style: {
      fill: "#bd1d83",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,144.35413,113.27107)",
    clipPath: "url(#clipPath2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3",
    d: "m 0,0 c -5.091,-1.985 -9.795,-3.586 -14.113,-4.803 -4.318,-1.217 -9.506,-1.825 -15.563,-1.825 -5.736,0 -9.731,0.992 -11.987,2.978 -2.255,2.049 -3.867,4.515 -4.833,7.397 -3.738,-3.011 -7.895,-5.508 -12.47,-7.493 -4.576,-1.922 -10.569,-2.882 -17.98,-2.882 -7.153,0 -12.953,1.216 -17.4,3.65 -4.382,2.498 -7.475,5.604 -9.28,9.318 -1.74,3.779 -2.61,7.653 -2.61,11.624 0,6.02 1.515,10.983 4.544,14.89 3.093,3.971 7.217,7.205 12.373,9.702 5.155,2.498 11.986,5.092 20.493,7.782 4.833,1.537 8.474,2.689 10.923,3.458 2.514,0.832 4.382,1.473 5.607,1.921 1.224,0.448 2.513,1.025 3.866,1.729 0,4.739 -0.966,8.454 -2.899,11.144 -1.934,2.69 -6.123,4.034 -12.567,4.034 -7.604,0 -14.661,-1.665 -21.17,-4.995 -6.509,-3.33 -12.47,-7.621 -17.883,-12.872 V 81.27 c 4.318,3.074 8.99,5.572 14.017,7.493 5.026,1.986 10.278,3.458 15.756,4.419 5.478,0.961 11.02,1.441 16.627,1.441 14.242,0 24.939,-2.754 32.093,-8.261 7.217,-5.444 10.826,-12.969 10.826,-22.575 V 26.033 c 0,-3.586 0.322,-6.276 0.967,-8.069 0.709,-1.729 1.965,-2.594 3.77,-2.594 2.191,0 5.155,0.929 8.893,2.786 z m -48.43,18.732 v 23.152 c -8.248,-3.33 -14.274,-6.34 -18.076,-9.03 -3.802,-2.626 -5.703,-6.212 -5.703,-10.759 0,-3.266 0.934,-5.764 2.803,-7.493 1.933,-1.729 4.157,-2.594 6.67,-2.594 2.384,0 4.737,0.64 7.057,1.921 2.384,1.345 4.801,2.946 7.249,4.803",
    style: {
      fill: "#bd1d83",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,300.6904,172.8308)",
    clipPath: "url(#clipPath4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5",
    d: "m 0,0 -66.893,-142.271 h -35.186 L -75.013,-85.017 -113.969,0 h 37.41 L -56.549,-48.608 -33.833,0 Z",
    style: {
      fill: "#bd1d83",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,444,48.972267)",
    clipPath: "url(#clipPath6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path7",
    d: "m 0,0 h 34 l -66.5,-142.5 h -37 z",
    style: {
      fill: "#ffcd3a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,398.66667,48.666667)",
    clipPath: "url(#clipPath8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9",
    d: "m 563.482,43.733 h -34.868 v 133.438 h 34.868 z",
    style: {
      fill: "#bd1d83",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,0,238.66667)",
    clipPath: "url(#clipPath10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11",
    d: "m 0,0 c 0,-4.044 -1.449,-7.477 -4.346,-10.301 -2.898,-2.825 -6.343,-4.237 -10.335,-4.237 -2.705,0 -5.184,0.642 -7.437,1.926 -2.19,1.284 -3.928,3.017 -5.216,5.199 -1.288,2.246 -1.932,4.717 -1.932,7.413 0,3.979 1.417,7.413 4.25,10.301 2.833,2.889 6.278,4.333 10.335,4.333 3.992,0 7.437,-1.444 10.335,-4.333 C -1.449,7.413 0,3.979 0,0 m 2.801,-120.633 h -34.868 v 98.008 H 2.801 Z",
    style: {
      fill: "#bd1d83",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,823.1164,19.511867)",
    clipPath: "url(#clipPath12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13",
    d: "m 0,0 c -3.606,-1.733 -8.596,-3.402 -14.971,-5.006 -6.31,-1.605 -12.363,-2.407 -18.158,-2.407 -25.049,0 -37.573,12.195 -37.573,36.584 v 39.088 h -15.743 v 6.066 l 46.651,47.367 h 3.96 V 92.328 H -2.608 V 68.259 H -35.834 V 36.874 c 0,-3.659 0.226,-6.611 0.676,-8.858 0.451,-2.246 1.707,-4.14 3.767,-5.68 2.125,-1.476 5.313,-2.214 9.562,-2.214 5.538,0 12.814,2.31 21.829,6.931 z",
    style: {
      fill: "#bd1d83",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,956.9972,172.7824)",
    clipPath: "url(#clipPath14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path15",
    d: "m 0,0 c -5.087,-1.99 -9.788,-3.594 -14.102,-4.814 -4.314,-1.219 -9.497,-1.829 -15.55,-1.829 -5.731,0 -9.723,0.995 -11.977,2.985 -2.254,2.053 -3.863,4.524 -4.829,7.413 -3.735,-3.017 -7.888,-5.52 -12.46,-7.51 -4.572,-1.925 -10.56,-2.888 -17.965,-2.888 -7.148,0 -12.943,1.219 -17.386,3.658 -4.379,2.504 -7.469,5.617 -9.272,9.339 -1.739,3.787 -2.608,7.67 -2.608,11.65 0,6.033 1.513,11.007 4.539,14.922 3.091,3.98 7.212,7.221 12.364,9.724 5.151,2.503 11.976,5.103 20.476,7.798 4.829,1.541 8.468,2.696 10.914,3.466 2.512,0.835 4.379,1.476 5.602,1.926 1.224,0.449 2.512,1.027 3.864,1.733 0,4.749 -0.966,8.472 -2.898,11.168 -1.931,2.695 -6.117,4.043 -12.556,4.043 -7.598,0 -14.649,-1.669 -21.153,-5.006 C -91.5,64.44 -97.456,60.14 -102.865,54.877 v 26.572 c 4.314,3.081 8.982,5.584 14.005,7.51 5.022,1.989 10.27,3.465 15.744,4.428 5.473,0.963 11.011,1.444 16.613,1.444 14.23,0 24.919,-2.76 32.066,-8.279 7.212,-5.456 10.818,-12.998 10.818,-22.625 V 26.091 c 0,-3.595 0.322,-6.29 0.966,-8.087 0.708,-1.733 1.964,-2.6 3.767,-2.6 2.189,0 5.151,0.931 8.886,2.792 z m -48.39,18.774 v 23.202 c -8.242,-3.337 -14.263,-6.354 -18.062,-9.05 -3.799,-2.631 -5.699,-6.226 -5.699,-10.783 0,-3.273 0.934,-5.776 2.802,-7.509 1.931,-1.733 4.153,-2.6 6.664,-2.6 2.383,0 4.733,0.642 7.051,1.926 2.382,1.348 4.797,2.952 7.244,4.814",
    style: {
      fill: "#bd1d83",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1116.1348,173.80933)",
    clipPath: "url(#clipPath16)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path17",
    d: "m 0,0 h -34.771 v 52.855 c 0,5.392 -0.902,10.077 -2.705,14.056 -1.738,4.044 -5.602,6.066 -11.59,6.066 -2.833,0 -5.345,-0.546 -7.534,-1.637 -2.125,-1.027 -4.057,-2.375 -5.795,-4.043 -1.674,-1.669 -3.091,-3.274 -4.25,-4.814 -1.159,-1.541 -2.35,-3.177 -3.574,-4.91 V 0 h -34.771 v 98.008 h 34.771 V 83.952 c 5.474,5.841 10.947,9.917 16.42,12.227 5.538,2.375 11.687,3.562 18.448,3.562 C -11.784,99.741 0,85.685 0,57.573 Z",
    style: {
      fill: "#bd1d83",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1270.6664,180.356)",
    clipPath: "url(#clipPath18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path19",
    d: "m 0,0 c 4.25,7.638 6.375,16.335 6.375,26.091 0,7.381 -1.191,14.12 -3.574,20.218 -1.215,3.108 -2.731,6.017 -4.548,8.725 1.386,1.808 2.92,3.528 4.603,5.16 4.829,4.685 10.753,8.28 17.772,10.783 7.019,2.503 15.132,3.755 24.34,3.755 9.272,0 17.45,-1.284 24.533,-3.851 7.147,-2.504 13.039,-6.034 17.675,-10.591 4.701,-4.557 8.243,-9.884 10.625,-15.981 2.383,-6.098 3.574,-12.837 3.574,-20.218 C 101.375,14.335 99.25,5.638 95,-2 90.75,-9.638 84.375,-15.671 75.876,-20.1 c -8.436,-4.428 -18.738,-6.643 -30.908,-6.643 -12.17,0 -22.505,2.215 -31.005,6.643 C 6.658,-16.264 0.922,-11.225 -3.244,-4.982 -2.052,-3.405 -0.971,-1.744 0,0 m 59.649,42.287 c 3.413,-4.365 5.119,-10.43 5.119,-18.196 0,-7.767 -1.706,-13.896 -5.119,-18.389 -3.348,-4.429 -8.242,-6.643 -14.681,-6.643 -6.31,0 -11.172,2.246 -14.585,6.739 -3.412,4.493 -5.119,10.591 -5.119,18.293 0,7.766 1.674,13.831 5.023,18.196 3.412,4.428 8.306,6.643 14.681,6.643 6.439,0 11.333,-2.215 14.681,-6.643",
    style: {
      fill: "#bd1d83",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,547.1232,147.0096)",
    clipPath: "url(#clipPath20)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path21",
    d: "m 0,0 c 0,-16.016 -12.984,-29 -29,-29 -16.016,0 -29,12.984 -29,29 0,16.016 12.984,29 29,29 C -12.984,29 0,16.016 0,0",
    style: {
      fill: "#ffcd3a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,525.33333,112)",
    clipPath: "url(#clipPath22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path23",
    d: "m 0,0 -18.5,-32.5 4,-4 16,27 C 7.5,-13 18.6,-20 37,-20 c 18.4,0 28,7 33.5,14 l -2,2 C 65.833,-7.333 55.8,-14 37,-14 18.2,-14 4.5,-5 0,0",
    style: {
      fill: "#ffcd3a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,438,159.33333)",
    clipPath: "url(#clipPath24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path25",
    d: "m 0,0 c -13,3 -25.833,-1.167 -33.5,-5 v 3.5 c 3,2 19,9.5 35,6 C 16.072,1.312 26.167,-11.333 28,-17 l -2,-1 C 24.667,-14.833 13.774,-3.179 0,0",
    style: {
      fill: "#ffcd3a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,502.66667,45.333333)",
    clipPath: "url(#clipPath26)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5e504cbd35a887987438ae44d7ef5068.svg";
export { ForwardRef as ReactComponent };